import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=6647112b&scoped=true"
import script from "@/views/Users/Student/Finished.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Finished.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/finished.scss?vue&type=style&index=0&id=6647112b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647112b",
  null
  
)

export default component.exports